import type { LoaderFunctionArgs, MetaFunction } from "react-router";
import { SITE_NAME, COUNTRY_CODES } from "@/lib/constants";
import FlagPage from "@/pages/FlagPage";

export async function loader({ params }: LoaderFunctionArgs) {
  const code = params.code!.toLowerCase();
  return { code };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const code = data?.code ?? "";
  const countryName = COUNTRY_CODES[code] || code.toUpperCase();
  const origin = "https://loadlogo.com";

  const title = `${countryName} Flag | ${SITE_NAME}`;
  const description = `${countryName} country flag in SVG and PNG. Fetch flags by ISO country code via the ${SITE_NAME} API.`;

  return [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:image", content: `${origin}/og/flag/${code}` },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:url", content: `${origin}/flag/${code}` },
    { property: "og:site_name", content: SITE_NAME },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: `${origin}/og/flag/${code}` },
    { tagName: "link", rel: "canonical", href: `${origin}/flag/${code}` },
  ];
};

export default function FlagRoute() {
  return <FlagPage />;
}
